<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 512 512"
  >
    <path
      :fill="color"
      d="M474.7,0H37.3C16.7,0,0,16.7,0,37.3v49.4c0,10.4,4.4,20.4,12.1,27.5l171.2,156.9c5.5,5,8.7,12.2,8.7,19.6V496c0,5.9,3.2,11.3,8.4,14.1c2.4,1.3,5,1.9,7.6,1.9c3.1,0,6.2-0.9,8.9-2.7l86.5-57.7c10.4-6.9,16.6-18.6,16.6-31.1V290.8c0-7.5,3.1-14.6,8.7-19.7l171.2-156.9c7.7-7.1,12.1-17.1,12.1-27.5V37.3C512,16.7,495.3,0,474.7,0z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
